import { observable } from 'mobx'
import { ERROR_MSG, CONSTS } from '../../constants/'

class RequestConsultationValidate {
  @observable value = ''
  @observable errors = []

  constructor (name, label, value = '', required = true) {
    this.name = name
    this.label = label
    this.required = required
    this.value = value
  }

  validate () {
    this.errors.replace([])
    switch (this.name) {
      case 'first_name':
        if ((!this.value || !this.value.length) && this.required) {
          this.errors.push(ERROR_MSG.ERR_ENROL_FNAME_REQ)
        }
        break
      case 'last_name':
        if ((!this.value || !this.value.length) && this.required) {
          this.errors.push(ERROR_MSG.ERR_ENROL_LNAME_REQ)
        }
        break
      case 'email':
        if ((!this.value || !this.value.length) && this.required) {
          this.errors.push(ERROR_MSG.ERR_ENROL_EMAIL_REQ)
        } else if (this.value.length > 0 && !CONSTS.EMAIL_REGEXP.test(this.value)) {
          this.errors.push(ERROR_MSG.ERR_USER_EMAIL)
        }
        break
      case 'phone':
        if ((!this.value || !this.value.length) && this.required) {
          this.errors.push(ERROR_MSG.ERR_ENROL_PHONE_REQ)
        } else if (this.value.length > 0 && !CONSTS.PHONE_REGEXP.test(this.value)) {
          this.errors.push(ERROR_MSG.ERR_ENROL_PHONE_ERR)
        }
        break
      default:break
    }
  }
}

export default RequestConsultationValidate
